import { ViewProcessor } from "./index";
import { View } from "../index";

export default class TabControlViewProcessor extends ViewProcessor
{
    public afterRender(view: View): PromiseLike<void>
    {
        function registerPage(headers: NodeListOf<Element>, pages: NodeListOf<Element>, index: number)
        {
            const targetHeader = headers[index];
            const targetPage = pages[index];

            targetHeader.addEventListener('click', e => 
            {
                for(let header of headers)
                {
                    header.classList.remove('visible');
                }

                for (let page of pages)
                {
                    page.classList.remove('visible');
                }

                targetHeader.classList.add('visible');
                targetPage.classList.add('visible');
            });
        }
        
        const tabControls = view.element.querySelectorAll('.tab-control');
        for(let tabControl of tabControls)
        {
            const tabHeaders = tabControl.querySelectorAll('.tab-header');
            const tabPages = tabControl.querySelectorAll('.tab-page');

            for(let i = 0; i < tabHeaders.length; i++)
            {
                registerPage(tabHeaders, tabPages, i);
            }
        }

        return super.afterRender(view);
    }
}